import { createRecipe } from './runtime';

const badgeConfig = {"name":"badge","defaultVariants":{"size":"md","tone":"neutral"},"variantMap":{"size":["lg","md","sm"],"tone":["advisory","allow","blocked","deny","info","neutral","notEvaluated","verified"]}}

export const badge = /* @__PURE__ */ createRecipe(badgeConfig)